module.exports = __webpack_public_path__ + "img/uploaddemo-1-a.4b47fe76.png";